import React from 'react'

export default function ErrorIcon(props) {

    return (
        <>
            <svg
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.7542 12.6999C27.1536 9.09215 33.5016 7.1665 39.9955 7.1665C44.3072 7.1665 48.5767 8.01576 52.5602 9.66579C56.5438 11.3158 60.1633 13.7343 63.2121 16.7832C66.261 19.832 68.6795 23.4515 70.3295 27.4351C71.9795 31.4186 72.8288 35.6881 72.8288 39.9998C72.8288 46.4937 70.9031 52.8417 67.2954 58.2411C63.6876 63.6405 58.5597 67.8488 52.5602 70.3339C46.5607 72.819 39.959 73.4692 33.59 72.2023C27.2209 70.9354 21.3706 67.8083 16.7788 63.2165C12.187 58.6247 9.05989 52.7744 7.79301 46.4053C6.52613 40.0363 7.17634 33.4346 9.66141 27.4351C12.1465 21.4356 16.3548 16.3077 21.7542 12.6999ZM24.9025 62.5881C29.37 65.5732 34.6224 67.1665 39.9955 67.1665C47.2005 67.1665 54.1105 64.3043 59.2052 59.2096C64.2999 54.1148 67.1621 47.2049 67.1621 39.9998C67.1621 34.6268 65.5688 29.3744 62.5837 24.9068C59.5986 20.4393 55.3557 16.9573 50.3917 14.9011C45.4276 12.8449 39.9653 12.3069 34.6955 13.3552C29.4257 14.4034 24.585 16.9908 20.7857 20.7901C16.9864 24.5894 14.399 29.4301 13.3508 34.6999C12.3026 39.9697 12.8405 45.432 14.8967 50.3961C16.9529 55.3601 20.4349 59.603 24.9025 62.5881Z"
                    fill="#FF3500"
                    stroke="#FF3500"
                />
                <path
                    d="M42.8288 53.3333C42.8288 54.8981 41.5602 56.1667 39.9954 56.1667C38.4306 56.1667 37.1621 54.8981 37.1621 53.3333C37.1621 51.7685 38.4306 50.5 39.9954 50.5C41.5602 50.5 42.8288 51.7685 42.8288 53.3333Z"
                    fill="#FF3500"
                    stroke="#FF3500"
                />
                <path
                    d="M37.992 24.6634C38.5233 24.132 39.244 23.8335 39.9954 23.8335C40.7469 23.8335 41.4676 24.132 41.9989 24.6634C42.5303 25.1947 42.8288 25.9154 42.8288 26.6668V43.3335C42.8288 44.0849 42.5303 44.8056 41.9989 45.337C41.4676 45.8683 40.7469 46.1668 39.9954 46.1668C39.244 46.1668 38.5233 45.8683 37.992 45.337C37.4606 44.8056 37.1621 44.0849 37.1621 43.3335V26.6668C37.1621 25.9154 37.4606 25.1947 37.992 24.6634Z"
                    fill="#FF3500"
                    stroke="#FF3500"
                />
            </svg>

        </>
    )
}
